module.exports = __webpack_public_path__ + "static/media/rocket.f95b37f7.jpg";